import React, {useEffect, useState} from "react";
import "./Header.scss";
import {
  achievementSection,
  bigProjects,
  blogSection,
  educationInfo,
  openSource,
  resumeSection,
  skillsSection,
  socialMediaLinks,
  talkSection,
  workExperiences
} from "../../portfolio";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showScrollHeader, setShowScrollHeader] = useState(false);
  const viewEducation = educationInfo.display;
  const viewExperience = workExperiences.display;
  const viewOpenSource = openSource.display;
  const viewSkills = skillsSection.display;
  const viewProjects = bigProjects.display;
  const viewAchievement = achievementSection.display;
  const viewBlog = blogSection.display;
  const viewTalks = talkSection.display;
  const viewResume = resumeSection.display;

  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollHeader(window.scrollY > window.innerHeight * 0.72);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, {passive: true});

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header className="main-header">
        <input
          checked={isMenuOpen}
          className="menu-btn"
          type="checkbox"
          id="menu-btn"
          onChange={() => setIsMenuOpen(current => !current)}
        />
        <label className="nav-button" htmlFor="menu-btn" aria-label="Menu">
          <span className="nos"></span>
          <span className="ncs"></span>
          <span className="nbs"></span>
          <div className="menu-button-text">Menu</div>
        </label>

        <nav className="nav-holder" aria-label="Main navigation">
          <div className="nav-title">
            <span>Menu</span>
          </div>
          <ul>
            <li>
              <a href="#greeting" onClick={closeMenu}>
                Home
              </a>
            </li>
            {viewEducation && (
              <li>
                <a href="#education" onClick={closeMenu}>
                  About
                </a>
              </li>
            )}
            {viewExperience && (
              <li>
                <a href="#experience" onClick={closeMenu}>
                  Resume
                </a>
              </li>
            )}
            {viewProjects && (
              <li>
                <a href="#projects" onClick={closeMenu}>
                  Projects
                </a>
              </li>
            )}
            {viewSkills && (
              <li>
                <a href="#skills" onClick={closeMenu}>
                  Skills
                </a>
              </li>
            )}
            {viewOpenSource && (
              <li>
                <a href="#opensource" onClick={closeMenu}>
                  Open Source
                </a>
              </li>
            )}
            {viewAchievement && (
              <li>
                <a href="#achievements" onClick={closeMenu}>
                  Achievements
                </a>
              </li>
            )}
            {viewBlog && (
              <li>
                <a href="#blogs" onClick={closeMenu}>
                  Blogs
                </a>
              </li>
            )}
            {viewTalks && (
              <li>
                <a href="#talks" onClick={closeMenu}>
                  Talks
                </a>
              </li>
            )}
            {viewResume && (
              <li>
                <a href="#resume" onClick={closeMenu}>
                  CV
                </a>
              </li>
            )}
            <li>
              <a href="#contact" onClick={closeMenu}>
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <div className="header-social">
          {socialMediaLinks.facebook && (
            <a href={socialMediaLinks.facebook} target="_blank" rel="noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
          )}
          {socialMediaLinks.linkedin && (
            <a href={socialMediaLinks.linkedin} target="_blank" rel="noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
          )}
          {socialMediaLinks.github && (
            <a href={socialMediaLinks.github} target="_blank" rel="noreferrer">
              <i className="fab fa-github"></i>
            </a>
          )}
          {socialMediaLinks.gmail && (
            <a href={`mailto:${socialMediaLinks.gmail}`}>
              <i className="fas fa-envelope"></i>
            </a>
          )}
        </div>

        <a className="show-share" href="#projects" aria-label="Go to projects">
          <i className="fas fa-retweet"></i>
          <span>Projects</span>
        </a>
      </header>

      <a
        className="contact-btn"
        href="https://wa.me/263713630190"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get in touch on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
        <span>Get in Touch</span>
      </a>

      <div
        className={`scroll-header ${showScrollHeader ? "scroll-header-visible" : ""}`}
      >
        <a className="scroll-header-down" href="#education">
          <span className="mousey">
            <span className="scroller"></span>
          </span>
          <span>Scroll Down</span>
        </a>
        <nav className="scroll-header-nav" aria-label="Page sections">
          <a href="#greeting">Home</a>
          {viewEducation && <a href="#education">About</a>}
          {viewExperience && <a href="#experience">Resume</a>}
          {viewProjects && <a href="#projects">Projects</a>}
          {viewSkills && <a href="#skills">Skills</a>}
          <a href="#contact">Contact</a>
        </nav>
      </div>
    </>
  );
}

export default Header;
